import React, { useState } from 'react'
import { ChevronLeft, ChevronRight, X, Search } from 'lucide-react'
import CompanySearchBox from '../utils/CompanySearchBox'

const categories = [
  {
    id: 'company_info',
    name: '企業情報',
    count: 20,
    fields: [
      { id: 'listing_date', name: '上場情報' },
      { id: 'fulltimeemployees', name: '従業員数' },
      { id: 'company_description', name: '事業内容' },
      { id: 'establishment_date', name: '設立年' },
      { id: 'fiscal_date', name: '決算期' },
      { id: 'industry_name', name: '業界' },
    ]
  },
  {
    id: 'financial_results',
    name: '財務情報',
    count: 22,
    fields: [
      { id: 'sales', name: '売上高' },
      { id: 'gross_profit', name: '売上総利益' },
      { id: 'operating_income', name: '営業利益' },
      { id: 'ordinary_income', name: '経常利益' },
      { id: 'net_income', name: '当期利益' },
      { id: 'equity_ratio', name: '自己資本比率' },
      { id: 'total_assets', name: '総資産' },
    ]
  },
  {
    id: 'market',
    name: 'マーケット情報',
    count: 22,
    fields: [
      { id: 'stock_price', name: '株価' },
      { id: 'per', name: 'PER' },
      { id: 'pbr', name: 'PBR' },
    ]
  },
  {
    id: 'dividend',
    name: '配当情報',
    count: 22,
    fields: [
      { id: 'dividend_payout', name: '配当額' },
      { id: 'payout_ratio', name: '配当性向'},
      { id: 'dividend_ratio', name: '配当率'},
    ]
  }
]

const CompanySelector = ({ isOpen, onClose, onSelect }) => {
  const [selectedCompany, setSelectedCompany] = useState(null)
  const [selectedFields, setSelectedFields] = useState([])
  const [graphDataType, setGraphDataType] = useState('stockPrice')
  const [expandedCategory, setExpandedCategory] = useState(null)
  const [searchTerm, setSearchTerm] = useState('')

  const onCompanySelect = (secCode, companyName) => {
    setSelectedCompany({secCode, companyName})
    const initialFields = []
    setSelectedFields(initialFields)
    updateSelectedData({secCode, companyName}, initialFields)
  }

  const addField = (field, category) => {
    if (!selectedFields.find((selected) => selected.id === field.id)) {
      field['category'] = category;
      const newFields = [...selectedFields, field]
      setSelectedFields(newFields)
      updateSelectedData(selectedCompany, newFields)
    }
  }

  const removeField = (field) => {
    const newFields = selectedFields.filter(f => f !== field)
    setSelectedFields(newFields)
    updateSelectedData(selectedCompany, newFields)
  }

  const updateSelectedData = (company, fields) => {
    const selectedData = fields
    onSelect(company, selectedData)
  }

  const toggleCategory = (categoryId) => {
    setExpandedCategory(expandedCategory === categoryId ? null : categoryId)
  }

  return (
    <div className={`fixed inset-y-0 right-0 w-[400px] align-left bg-white shadow-lg transform ${isOpen ? 'translate-x-0' : 'translate-x-full'} transition-transform duration-300 ease-in-out z-50 overflow-y-auto`}>
      <div className="p-4">
        <button
          className="mb-4 flex text-gray-600 hover:text-gray-800"
          onClick={onClose}
        >
          <ChevronLeft className="w-5 h-5 mr-2" />
          戻る
        </button>

        <div className="text-lg align-left font-semibold text-gray-400 mb-2">企業を選択</div>
        <CompanySearchBox onCompanySelect={onCompanySelect}/>
        {selectedCompany && (
          <div>
            {/* <div className="mt-1 mb-4 align-left">{selectedCompany.companyName} ({selectedCompany.secCode})</div> */}
            
            <div className="text-lg align-left font-semibold text-gray-400 mb-2">表示項目を選択</div>
            <div className="relative mb-4">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input
                type="text"
                placeholder="Search properties..."
                className="w-full pl-10 pr-4 py-2 border border-blue-500 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="space-y-1">
              {categories.map((category) => (
                <div key={category.id}>
                  <button
                    onClick={() => toggleCategory(category.id)}
                    className="w-full flex items-center justify-between px-2 py-2 text-left hover:bg-gray-50 rounded-lg"
                  >
                    <div className="flex items-center">
                      <ChevronRight 
                        className={`w-4 h-4 mr-2 transition-transform ${expandedCategory === category.id ? 'transform rotate-90' : ''}`}
                      />
                      <span>{category.name}</span>
                    </div>
                    <span className="text-gray-500">({category.count})</span>
                  </button>
                  
                  {expandedCategory === category.id && (
                    <div className="ml-6 space-y-1">
                      {category.fields
                        .filter(field => field.name.toLowerCase().includes(searchTerm.toLowerCase()))
                        .map((field) => (
                          <button
                            key={field.id}
                            onClick={() => addField(field, category.id)}
                            className="w-full text-left px-4 py-2 hover:bg-gray-50 rounded-lg"
                            disabled={selectedFields.find((selected) => selected.id === field.id)}
                          >
                            {field.name}
                          </button>
                        ))
                      }
                    </div>
                  )}
                </div>
              ))}
            </div>

            {selectedFields.length > 0 && (
              <div className="mt-4">
                <div className="text-lg text-gray-400 font-semibold mb-2">選択済みの項目</div>
                {selectedFields.map(field => (
                  <div key={field.id} className="flex justify-between items-center mb-2 px-2 py-1 bg-gray-50 rounded-lg">
                    <span>{field.name}</span>
                    <button onClick={() => removeField(field)} className="text-red-500 hover:text-red-700">
                      <X className="w-4 h-4" />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default CompanySelector